import { apiUrl, getApiBase } from '../utils/apiUrl';
/**
 * Servicio de búsqueda de películas, series y música (TMDB/Last.fm vía backend).
 */


async function searchMovies(query) {
  const res = await fetch(apiUrl(`/api/search/movies?q=${encodeURIComponent(query)}`), {
    credentials: 'include',
    cache: 'no-store'
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Error ${res.status}`);
  }
  const data = await res.json();
  return data.results || [];
}

async function searchSeries(query) {
  const res = await fetch(apiUrl(`/api/search/series?q=${encodeURIComponent(query)}`), {
    credentials: 'include',
    cache: 'no-store'
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Error ${res.status}`);
  }
  const data = await res.json();
  return data.results || [];
}

async function searchMusic(query, genre = '') {
  const params = new URLSearchParams();
  if (query) params.append('q', query);
  if (genre) params.append('genre', genre);
  const res = await fetch(apiUrl(`/api/search/music?${params.toString()}`), {
    credentials: 'include',
    cache: 'no-store'
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Error ${res.status}`);
  }
  const data = await res.json();
  return data.results || [];
}

export default {
  searchMovies,
  searchSeries,
  searchMusic
};
